import { render, staticRenderFns } from "./modifyuser.vue?vue&type=template&id=0cb5d388&scoped=true&"
import script from "./modifyuser.vue?vue&type=script&lang=js&"
export * from "./modifyuser.vue?vue&type=script&lang=js&"
import style0 from "./modifyuser.vue?vue&type=style&index=0&id=0cb5d388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5d388",
  null
  
)

export default component.exports